/**
 * Search page — instant search with debounce.
 */
import { esc, stars } from '../lib/helpers.js';

(() => {
  const input = document.getElementById('search-input');
  const results = document.getElementById('search-results');
  if (!input || !results) return;

  let timer = null;
  let last = '';

  const search = (q) => {
    if (q.length < 2) { results.innerHTML = ''; return; }
    if (q === last) return;
    last = q;

    results.innerHTML = '<div class="text-center py-8"><span class="loading loading-spinner loading-md text-blue-600"></span></div>';

    fetch(`/api?q=${encodeURIComponent(q)}&limit=20`)
      .then(r => r.json())
      .then(d => {
        if (!d.ok || !d.results || d.results.length === 0) {
          results.innerHTML = `<p class="text-slate-500 text-center py-8">No results found for "${esc(q)}"</p>`;
          return;
        }

        let html = '<div class="space-y-3">';
        d.results.forEach(biz => {
          const slug = biz.biz_slug;
          const url = slug ? `/biz/${esc(slug)}/` : '#';
          const logo = biz.logo_url
            ? `<img src="${esc(biz.logo_url)}" alt="" class="w-10 h-10 rounded-lg object-cover bg-slate-100">`
            : `<div class="w-10 h-10 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm">${esc((biz.name || '?')[0])}</div>`;

          html += `<a href="${url}" class="flex items-center gap-3 p-3 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-sm transition-all bg-white">`;
          html += logo;
          html += '<div class="flex-1 min-w-0">';
          html += `<p class="font-semibold text-slate-900 text-sm truncate">${esc(biz.name || '')}</p>`;
          html += '<div class="flex items-center gap-2 text-xs text-slate-500 mt-0.5">';
          if (biz.city && biz.state) html += `<span>${esc(biz.city)}, ${esc(biz.state)}</span>`;
          if (biz.category) html += `<span class="text-slate-300">&middot;</span><span>${esc(biz.category)}</span>`;
          html += '</div>';
          if (biz.rating) {
            html += `<div class="flex items-center gap-1.5 mt-1"><span class="text-amber-500 text-xs">${stars(biz.rating)}</span><span class="text-xs text-slate-400">${biz.rating}</span>`;
            if (biz.review_count) html += `<span class="text-xs text-slate-400">(${biz.review_count})</span>`;
            html += '</div>';
          }
          html += '</div>';
          html += '<svg class="w-4 h-4 text-slate-300 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
          html += '</a>';
        });
        html += '</div>';
        if (d.hasMore) html += '<p class="text-center text-xs text-slate-400 mt-4">Showing first 20 results</p>';
        results.innerHTML = html;
      })
      .catch(() => {
        results.innerHTML = '<p class="text-slate-400 text-center py-8">Search unavailable. Please try again.</p>';
      });
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => search(input.value.trim()), 300);
  });

  // Check URL for ?q= param
  const params = new URLSearchParams(window.location.search);
  const q = params.get('q');
  if (q) { input.value = q; search(q); }

  input.focus();
})();
